import React, { ReactNode } from "react";
import MSpinner from "./MSpinner";

interface Props {
  loadingMessages: ReactNode[],
};

/** @description Shows a Loading Cover over all of the elements that are in the same parent. Parent element must have position: relative */
const LoadingCover = ({ loadingMessages }: Props) => {
  return (
    <div className="loading-cover">
      <div className="loading-content">
        <MSpinner />
        {loadingMessages.map(m => <div className="loading-message">{m}</div>)}
      </div>
    </div>
  );
};

export default LoadingCover;
